var YTPlayer = require('luminoslabs/_yt-player');

class VideoSlider {
    constructor(el) {

        this.parent = $(el);
        this.slider = this.parent.find('.video-slider__slider');
        this.slides = this.slider.find('.video-slider__slide');
        this.videoCount = this.slides.find('[data-video-id]');
        this.triggers = this.parent.find('.video-slider__trigger');
        this.next = this.parent.find('.video-slider__trigger--next');
        this.prev = this.parent.find('.video-slider__trigger--prev');
        this.players = [];
        this.activePlayer = 0;
        this.initVideos();
    }
    initVideos() {

        this.slides.each((index, v) => {
            var video = $(v).find('.video-module');
            const $video = $(video);
            const videoId = $video.attr('data-video-id') || '';
            const videoType = $video.attr('data-video-type') || '';
            const videoDiv = $video.find('.video-module__wrapper');


            if (videoType === 'youtube' && this.isIosWithIssue()) {
                const youtubeIframeStr =
                    `<iframe src="https://www.youtube.com/embed/${videoId}" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`;
                videoDiv.html(youtubeIframeStr).addClass('has-iframe');
                return;
            }

            if (videoType === 'vimeo' && this.isIE10()) {
                const vimeoIframeStr =
                    `<iframe src="https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`;
                videoDiv.html(vimeoIframeStr).addClass('has-iframe');
                return;
            }

            switch (videoType) {
                case 'vimeo':
                    this.loadVimeoVideo(videoId, $video, index);
                    break;
                case 'youtube':
                    this.loadYoutubeVideo(videoId, $video, index);
                default:
                    break;
            }
        });

        this.slider.on("afterChange", function(event, slick, currentSlide){
            this.pausePlayers()

            this.activePlayer = slick.currentSlide;
            if( slick.$slides.length === (slick.currentSlide + 1)) {
                this.prev.removeClass("hidden")
                this.next.addClass("hidden")
            } else if( slick.currentSlide === 0 ) {
                this.prev.addClass("hidden")
                this.next.removeClass("hidden")
            } else {
                this.triggers.removeClass("hidden")
            }

        }.bind(this) )
        .on("init", function(event, slick, currentSlide){
            this.pausePlayers();

           if( slick.$slides.length === (slick.currentSlide + 1)) {
                this.prev.removeClass("hidden")
                this.next.addClass("hidden")

            } else if( slick.currentSlide === 0 ) {

                this.prev.addClass("hidden")
                this.next.removeClass("hidden")
            } else {
                this.triggers.removeClass("hidden")
            }

        }.bind(this))

        var sliderSettings = {
            dots: false,
            autoplay: false,
            arrows: false,
            infinite: false,
            draggable: false
        };

        $(window).on('resize', function() {
            if ($(window).width() >= 768 ) {
                if (!this.slider.hasClass('slick-initialized')) {
                    this.slider.slick( sliderSettings );
                }
            } else {
                if (this.slider.hasClass('slick-initialized')) {
                    this.slider.slick('unslick');
                }
            }
        }.bind(this)).trigger("resize");

        this.next.on("click", function() {
            this.slider.slick("slickNext")

        }.bind(this));

        this.prev.on("click", function() {
            this.slider.slick("slickPrev")
        }.bind(this));
    }

    loadVimeoVideo(videoId, slide, index) {
        var thumbnailWidth = this.getThumbnailWidth();

         $.ajax({
            type:'GET',
            url: 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + videoId + '&width=' + thumbnailWidth,
            dataType: 'jsonp',
            cache: false,
            headers: {
                "Content-Security-Policy": "child-src https: data:; frame-src https: data:; media-src https:;"
            }
        })
        .done((data) => {
            const titleElem = slide.find('.video-content__title');
            const durationElem = slide.find('.video-content__time');

            titleElem.text(data.title);
            durationElem.text(this.getTime(data.duration));

            slide.find('.video-content').css('background-image', `url(${data.thumbnail_url})`);
            this.setVimeoVideo(videoId, slide, index);
         })
        .fail((err) => {
            throw new Error('Error loading vimeo video.');
        });
    }

    loadYoutubeVideo(videoId, slide, index) {
        $.ajax({
            type: 'GET',
            url: 'https://www.googleapis.com/youtube/v3/videos',
            data: {
                key: 'AIzaSyDqjaX9ly_IMTWOsDLiKddLpT4WW7qWDkU',
                id: videoId,
                part: 'snippet,contentDetails'
            },
            dataType: 'json',
            cache: false
        })
        .done((data) => {
            const title = data.items[0].snippet.title;
            const duration = this.convertYoutubeDurationToTime(data.items[0].contentDetails.duration);
            const thumbnail = this.chooseYoutubeThumbnail(data.items[0].snippet.thumbnails);
            const titleElem = slide.find('.video-content__title');
            const durationElem = slide.find('.video-content__time');

            slide.find('.video-content').css('background-image', `url(${thumbnail.url})`);

            titleElem.text(title);
            durationElem.text(duration);
            this.setYoutubeVideo(videoId, slide, index);
        })
        .fail(function (err) {
            throw new Error('Error loading slider youtube video.');
        });
    }

    playVideo(e, i) {
        const slide = this.slides.eq( i );

        this.players[i].play();
        slide.find('.video-module__wrapper').fadeIn( 300 );
    }

    pausePlayers() {
        this.slider.find('.video-module__wrapper:not(.has-iframe)').fadeOut( 300 )
        this.players.length !== 0 && this.players.forEach( player => {
            player.pause()
        });
    }

    setVimeoVideo(videoId, slide, index) {
        var options = {
            id: videoId,
            //width: 1400,
            loop: false,
            byline : false,
            title: false,
            portrait: false
        };

        const player = new Vimeo.Player(slide.find('.video-module__wrapper')[0], options);
        slide.find('.video-module__wrapper').fadeOut( 100 );

        player.ready().then(() => {
            this.players[index] = player;
            slide.find(".video-content__button").off().on("click",  (e) => {
                this.playVideo(e, index)
            });
        });
    }

    setYoutubeVideo(videoId, slide, index) {
        const opts = {
            width: 1280,
            height: 720,
            autoplay: false,
            loop: false
        };

        const ytElem = slide.find('.youtube-iframe');
        const player = new YTPlayer(ytElem[0], opts);

        player.load(videoId, false);
        player.setVolume(100);
        slide.find('.video-module__wrapper').fadeOut(100);
        this.players[index] = player;
        slide.find(".video-content__button").off().on("click", (e) => {
            this.playVideo(e, index)
        });
    }

    getTime(total) {
        const minutes = Math.floor(total / 60);
        const seconds = total % 60;

        return (minutes !== 0 ? (`${minutes}:`) : '0:') + seconds;
    }

    convertYoutubeDurationToTime(duration) {
        const reptms = /^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/;
        let hours = 0, minutes = 0, seconds = 0;

        if (reptms.test(duration)) {
            const matches = reptms.exec(duration);
            if (matches[1]) hours = Number(matches[1]);
            if (matches[2]) minutes = Number(matches[2]);
            if (matches[3]) seconds = Number(matches[3]);
        }

        const hoursStr = hours ? (hours + ":") : '';
        const minutesStr = minutes ? (minutes + ":") : '0:';
        return (hoursStr + minutesStr + seconds);
    }

    chooseYoutubeThumbnail(thumbnails) {
        const thumbnailWidth = this.getThumbnailWidth();
        let thumbnail;

        if (thumbnailWidth <= 480) {
            thumbnail = thumbnails.medium;
        } else if (thumbnailWidth <= 640) {
            thumbnail = thumbnails.high;
        } else if(thumbnailWidth <= 991) {
            thumbnail = thumbnails.standard;
        } else {
            thumbnail = thumbnails.maxres;
        }

        return thumbnail;
    }

    getThumbnailWidth() {
        const devicePixelRatio = window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI;
        const windowWidth = $(window).width();

        return Math.round(devicePixelRatio * windowWidth);
    }

    getiOSversion() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
        }

        return 0;
    }

    isIosWithIssue() {
        const iosVersion = this.getiOSversion();
        return (iosVersion && iosVersion[0] < 10 && iosVersion[0] > 6)
    }

    isIE10() {
        return navigator.appVersion.indexOf("MSIE 10") !== -1;
    }
}

$(() => {
    $.fn.videoSlider = function() {
        $(this).each((index, slider) => new VideoSlider(slider));
    };
});
